export default function (state) {
    return state.items.concat([]).sort((a, b) => {
        return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    });
}